import { defineStore } from "pinia";
import { ref } from "vue";

export const useAppStateStore = defineStore("AppState", () => {
  const isLoading = ref(false);
  const loadingText = ref();
  const waitForRouteChange = ref(false);

  const activateWaitForRouteChange = () => {
    waitForRouteChange.value = true;
  };

  const showLoadingOverlay = (text?: string) => {
    isLoading.value = true;
    loadingText.value = text;
  };

  const hideLoadingOverlay = () => {
    isLoading.value = false;
    waitForRouteChange.value = false;
  };

  return {
    isLoading,
    loadingText,
    waitForRouteChange,
    activateWaitForRouteChange,
    showLoadingOverlay,
    hideLoadingOverlay,
  };
});
